import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;

//组织

export function getOrganizationTree(organizationId,includeRemoved) {

  let url = apiUrl + '/api/Organization/GetOrganizationTree?1=1';
  if(organizationId)
  {
    url += '&organizationId='+organizationId;
  }
  if(includeRemoved)
  {
    url += '&includeRemoved='+includeRemoved;
  }

  return fetch({
    url: url,
    method: 'post',
  })
}
export function createOrganization(data) {
  return fetch({
    url: apiUrl + '/api/Organization/CreateOrganization',
    method: 'post',
    data
  })
}
export function updateOrganization(data) {
  return fetch({
    url: apiUrl + '/api/Organization/UpdateOrganization',
    method: 'post',
    data
  })
}
export function removeOrganization(data) {
  return fetch({
    url: apiUrl + '/api/Organization/RemoveOrganization?id='+data,
    method: 'post'
  })
}

export function recoverOrganization(data) {
  return fetch({
    url: apiUrl + '/api/Organization/RecoverOrganization?id='+data,
    method: 'post'
  })
}

export function getOrganization(data) {
  return fetch({
    url: apiUrl + '/api/Organization/GetOrganization?id='+data,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/organizationApi.js